namespace('compass.hotel');

compass.hotel.StarRatingWidget = compass.defineWidget(function StarRatingWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var starSettings = Number(_settings.stars);

	var _setupControls = this.setupControls = function() {

	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		widgetElem.append(me.drawStarRating());

		_setupControls();
	};

	this.drawStarRating = function() {
		var d = _d;
		// Round down starSettings to get # of whole stars, then add a half star and empty star(s) if necessary and save them all in starElements array to be rendered as icons
		var wholeStars = Math.floor(starSettings);
		var halfStars = (wholeStars === starSettings) ? 0 : 1;
		var emptyStars = 5-halfStars-wholeStars;

		var starElements = [ ];

		if(starSettings > 0) {
				_.times(wholeStars, function() { starElements.push( d.i({className: 'fa-solid fa-star',        'aria-hidden' : true})); });
				_.times(halfStars , function() { starElements.push( d.i({className: 'fa-duotone fa-star-half', 'aria-hidden' : true})); });
				_.times(emptyStars, function() { starElements.push( d.i({className: 'fa-solid fa-star empty',  'aria-hidden' : true})); });
			return d.span({ className : "starRatingDiv", title : starSettings + ' stars'},
					starElements 
					);
		} else {
			return d.div({ className : "emptyStarRatingDiv", title : 'No star rating' });
		}
	};


	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultStarRatingWidgetWUID',
	widgetName : 'StarRatingWidget',
	imgPath : '/resources/img',
	subclass : false,
	stars : 0
});

